"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_IMAGE = exports.N12_DESCRIPTION = exports.DESCRIPTION = exports.N12_TITLE_TEMPLATE = exports.TITLE_TEMPLATE = exports.UNORDERED_ITEM_POSITION = exports.VARY_HEADER = exports.CACHE_CONTROL_HEADER = exports.PUBLIC_SUBMISSIONS_PAGE_SIZE = exports.QS_STRINGIFY_OPTIONS = void 0;
exports.QS_STRINGIFY_OPTIONS = { arrayFormat: 'comma', skipNulls: true };
exports.PUBLIC_SUBMISSIONS_PAGE_SIZE = 24; // 24
var DAY = 60 * 60 * 24;
exports.CACHE_CONTROL_HEADER = "public, max-age=".concat(1 * DAY);
exports.VARY_HEADER = 'origin, accept-encoding';
exports.UNORDERED_ITEM_POSITION = 999999999;
exports.TITLE_TEMPLATE = 'הדלקתי נר לזכר {role} {name} ז"ל {city}';
exports.N12_TITLE_TEMPLATE = 'לזכר {role} {name} ז"ל {city}';
exports.DESCRIPTION = 'הדליקו נר לזכר הנרצחים והנופלים במלחמת חרבות ברזל 2023';
exports.N12_DESCRIPTION = "{description} \u05DE\u05EA\u05D9\u05D9\u05D7\u05D3\u05D9\u05DD \u05E2\u05DD \u05D4\u05D4\u05E8\u05D5\u05D2\u05D9\u05DD \u05D5\u05D4\u05E0\u05E8\u05E6\u05D7\u05D9\u05DD \u05D1\u05D0\u05EA\u05E8 N12";
exports.DEFAULT_IMAGE = 'https://img.mako.co.il/2023/10/15/placeholder-pic.png';
//# sourceMappingURL=other.js.map